module.exports = __webpack_public_path__ + "img/图片4.329cf768.jpg";